import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
export default {
  computed: _objectSpread({}, mapGetters('d2admin/user', ['name'])),
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/user', ['logout'])), {}, {
    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout();
    }
  })
};